import CaretDownOutline from './CaretDownOutline'

export default CaretDownOutline
// eslint-disable-next-line import/export
export * from './CaretDownOutline'
